import WCContactDetailsView from 'text!../views/wc-contact-details.html';
import WCContactDetailsCtrl from '../controllers/WCContactDetailsCtrl';
import WCPreQualQuestionsView from 'text!edge/quoteandbind/common/views/prequal-questions.html';
import WCPreQualQuestionsCtrl from '../controllers/WCPrequalQuestionsCtrl';
import WCNamedInsuredView from 'text!../views/wc-named-insured.html';
import WCNamedInsuredCtrl from '../controllers/WCNamedInsuredCtrl';
import WCLocationsView from 'text!../views/wc-locations.html';
import WCLocationsCtrl from '../controllers/WCLocationsCtrl';
import WCStateCoveragesView from 'text!../views/wc-state-coverages.html';
import WCStateCoveragesCtrl from '../controllers/WCStateCoveragesCtrl';
import WCPolicyCoveragesView from 'text!../views/wc-policy-coverages.html';
import WCPolicyCoveragesCtrl from '../controllers/WCPolicyCoveragesCtrl';
import WCOwnersAndOfficersView from 'text!../views/wc-owners-and-officers.html';
import WCOwnersAndOfficersCtrl from '../controllers/WCOwnersAndOfficersCtrl';
import WCGeneralInfoQuestionsView from 'text!../views/wc-general-info-questions.html';
import WCGeneralInfoQuestionsCtrl from '../controllers/WCGeneralInfoQuestionsCtrl';
import WCPolicyReviewView from 'text!../views/wc-policy-review.html';
import WCPolicyReviewCtrl from '../controllers/WCPolicyReviewCtrl';
import WCQuoteView from 'text!../views/wc-quote.html';
import WCQuoteCtrl from '../controllers/WCQuoteCtrl';
import WCPaymentsView from 'text!../views/wc-payments.html';
import WCPaymentsCtrl from '../controllers/WCPaymentsCtrl';
import WCConfirmationView from 'text!../views/wc-confirmation.html';
import WCConfirmationCtrl from '../controllers/WCConfirmationCtrl';
import WCPolicyInfoView from 'text!../views/wc-policy-info.html';
import WCPolicyInfoCtrl from '../controllers/WCPolicyInfoCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        wcContactDetails: {
            parent: wizardParentState,
            template: WCContactDetailsView,
            controller: WCContactDetailsCtrl
        },
        wcPrequalQuestions: {
            parent: wizardParentState,
            controller: WCPreQualQuestionsCtrl,
            template: WCPreQualQuestionsView
        },
        wcNamedInsured: {
            parent: wizardParentState,
            controller: WCNamedInsuredCtrl,
            template: WCNamedInsuredView
        },
        wcLocations: {
            parent: wizardParentState,
            controller: WCLocationsCtrl,
            template: WCLocationsView
        },
        wcStateCoverages: {
            parent: wizardParentState,
            controller: WCStateCoveragesCtrl,
            template: WCStateCoveragesView
        },
        wcPolicyCoverages: {
            parent: wizardParentState,
            controller: WCPolicyCoveragesCtrl,
            template: WCPolicyCoveragesView
        },
        wcOwnersAndOfficers: {
            parent: wizardParentState,
            controller: WCOwnersAndOfficersCtrl,
            template: WCOwnersAndOfficersView
        },
        wcGeneralInfoQuestions: {
            parent: wizardParentState,
            controller: WCGeneralInfoQuestionsCtrl,
            template: WCGeneralInfoQuestionsView
        },
        wcPolicyReview: {
            parent: wizardParentState,
            controller: WCPolicyReviewCtrl,
            template: WCPolicyReviewView
        },
        wcQuote: {
            parent: wizardParentState,
            controller: WCQuoteCtrl,
            template: WCQuoteView
        },
        wcPayments: {
            parent: wizardParentState,
            controller: WCPaymentsCtrl,
            template: WCPaymentsView
        },
        wcConfirmation: {
            parent: wizardParentState,
            controller: WCConfirmationCtrl,
            template: WCConfirmationView
        },
        wcPolicyInfo: {
            parent: wizardParentState,
            controller: WCPolicyInfoCtrl,
            template: WCPolicyInfoView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/wc/config/RouteConfig.js
// module id = 1292
// module chunks = 0